<script setup>
// import i18n from "@/i18n"
import {
    toRefs, defineProps, defineEmits, inject, ref, onMounted,
    // watch
} from "vue";
import { useRoute } from "vue-router";
import Swal from "sweetalert2";
import copySvg from "@/assets/images/svg/copy.svg"
const showType = inject('showType')
import { getProductTemplateMenu } from "@/service"
import { showMessage } from "@/utils/hooks/message"
import { getLangValue, getLangValueByKey } from "@/utils/common"; //获取后端语言
const currentTabLang = inject('currentTabLang') //切换语言
const props = defineProps({
    compositionStructureList: {
        type: Array,
        required: true,
        default: () => []
    },
    hscodeList: {
        type: Array,
        required: true,
        default: () => []
    }
})
const isCheckForm = inject('isCheckForm')
const route = useRoute()
const emits = defineEmits(["update:compositionStructureList"])
const { compositionStructureList } = toRefs(props)
//方法
const menuList = ref([])
const getTemplateMenu = async () => {
    let data = sessionStorage.getItem('t_menuList') ? JSON.parse(sessionStorage.getItem('t_menuList')) : []
    if (data.length > 0) {
        data.push({ name: getLangValueByKey("base.none"), name_en: getLangValueByKey("base.none", 'en'), role_key: '无', })
        menuList.value = data
    } else {
        const resp = await getProductTemplateMenu();
        if (resp) {
            resp.payload.push({ name: getLangValueByKey("base.none"), name_en: getLangValueByKey("base.none", 'en'), role_key: '无' })
            menuList.value = resp.payload
        }
    }

}
const editFields = (i) => {
    //tab 字段名称修改
    const { name, name_en } = compositionStructureList.value[i];
    Swal.fire({
        title:currentTabLang.value ==1?  getLangValueByKey("product-template.enterFieldName"): getLangValueByKey("product-template.enterFieldName", 'en'),
        input: "text",
        inputValue: currentTabLang.value == 1 ? name : name_en,
        showCancelButton: true,
        confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
        cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
        showLoaderOnConfirm: true,
        confirmButtonColor: "#0AB39c",
        cancelButtonColor: "#f06548",
        inputValidator: (value) => {
            if (!value) {
                return currentTabLang.value == 1? getLangValueByKey("product-template.requeiredInfo"): getLangValueByKey("product-template.requeiredInfo", 'en')
            }
        },
        preConfirm: (value) => {
            if (value) {
                if (currentTabLang.value == 1) {
                    compositionStructureList.value[i].name = value
                } else {
                    compositionStructureList.value[i].name_en = value
                }
                emits('update:compositionStructureList', compositionStructureList.value)
            }
        },
        allowOutsideClick: false,
    }).then((text) => {
        console.log(text);
    });
}

const handler = (type, i = "") => {
    switch (type) {
        case "copy": {
            let m = {
                name: compositionStructureList.value[i].name + `${compositionStructureList.value.length}`,
                name_en: compositionStructureList.value[i].name_en + `${compositionStructureList.value.length}`,
                value: '',
                value_en: '',
                showDelete: true,
                tableList: [],
                tableData: [],
                inputVal: '',
                required: false,
            }
            compositionStructureList.value.push(m)
            emits('update:compositionStructureList', compositionStructureList.value)
            break;
        }
        case "delete": {
            Swal.fire({
                title: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_title"): getLangValueByKey("base.delete_alert_title", 'en'),
                text: currentTabLang.value ==1?getLangValueByKey("base.delete_alert_info"): getLangValueByKey("base.delete_alert_info", 'en'),
                icon: "warning",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: currentTabLang.value ==1?  getLangValueByKey("base.done"): getLangValueByKey("base.done", 'en'),
                cancelButtonText: currentTabLang.value ==1?  getLangValueByKey("base.cancel"): getLangValueByKey("base.cancel", 'en'),
            }).then(async (result) => {
                if (result.isConfirmed) {
                    compositionStructureList.value.splice(i, 1)
                    emits('update:compositionStructureList', compositionStructureList.value)
                }
            });

            break;
        }
        case 'switch': {
            // 切换展示
            console.log(compositionStructureList.value[i].isShow);
            // compositionStructureList.value[i].isShow = !compositionStructureList.value[i].isShow
            emits('update:compositionStructureList', compositionStructureList.value)
            break;
        }
        default:
            break;
    }
}
const changeCheck = (item, index) => {
    // 选择数据
    if(!compositionStructureList.value[index].extra){
        compositionStructureList.value[index].extra = {}
    }
    if ((item.value == getLangValueByKey("base.none") || item.value_en == getLangValueByKey("base.none", 'en')) && item.required) {
        showMessage('danger', getLangValue("product-template.checkerr"))
        compositionStructureList.value[index].required = false;
        compositionStructureList.value[index].extra.template_type = '';
    }
    let arr = menuList.value.filter(menu=> menu.role_key == compositionStructureList.value[index].value)
    if(arr.length > 0) {
        compositionStructureList.value[index].extra.template_type = arr[0].template_type
    }
    // if (currentTabLang.value == 1) {
    //     if (compositionStructureList.value[index].value) {
    //         let arr_obj = menuList.value.find(item => item.name == compositionStructureList.value[index].value)
    //         if (arr_obj) {
    //             compositionStructureList.value[index].value_en = arr_obj.name_en
    //         }
    //     }

    // } else {
    //     if (compositionStructureList.value[index].value_en) {
    //         let arr_obj = menuList.value.find(item => item.name_en == compositionStructureList.value[index].value_en)
    //         if (arr_obj) {
    //             compositionStructureList.value[index].value = arr_obj.name
    //         }
    //     }

    // }
    emits('update:compositionStructureList', compositionStructureList.value)
}
onMounted(() => {
    getTemplateMenu()
})

// watch(compositionStructureList, (vla)=> {
//     console.log(vla);
// }, {deep: true})
</script>
<template>
    <template v-for="(item, index) in compositionStructureList" :key="index">
        <b-card class="product-template-compositionStructure"
            v-show="route.query.type != 'view' || (route.query.type == 'view' && item.isShow)">
            <div class="row gy-3 w-100">
                <div class="d-flex justify-content-between align-items-center pt-2 pb-2"
                    style="font-weight: 500;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                    <div class="d-flex align-items-center">
                        <span v-if="route.query.type == 'view'">
                            <span class="text-danger" v-if="item.required">*</span>
                        </span>
                        <input v-else @change="changeCheck(item, index)" class="form-check-input mt-0" type="checkbox"
                            v-model="item.required" aria-label="Checkbox for following text input">
                        <span class="mx-2">{{ currentTabLang == 1 ? item.name : item.name_en }}</span>
                        <i v-if="route.query.type != 'view'" class="ri-pencil-fill cursor-pointer"
                            @click.stop="editFields(index)"></i>
                    </div>
                    <div style="width: 135px;" class="d-flex align-items-center justify-content-between"
                        v-if="route.query.type != 'view'">
                        <!-- <button :disabled="route.query.type == 'view'" type="button" class="btn btn-success me-3"
                        @click="handler('copy')">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        {{ $t("base.copy") }}
                    </button>
                    <button :disabled="route.query.type == 'view'" v-show="item.showDelete" type="button"
                        class="btn btn-success me-3" style="background-color: #F06548;border:unset"
                        @click="handler('delete', index)">
                        <i class="ri-delete-bin-5-fill me-1 align-bottom"></i>
                        {{ $t("base.delete") }}
                    </button> -->
                        <!-- 是否显示 -->
                        <!-- <b-form-checkbox v-model="item.isShow" switch @change="handler('switch', index)"></b-form-checkbox> -->
                        <div class="form-check form-switch form-switch-success">
                            <input class="form-check-input" v-model="item.isShow" @change="handler('switch', index)"
                                type="checkbox" role="switch" id="SwitchCheck3" checked>
                        </div>
                        <img class="cursor-pointer" :src="copySvg" @click="handler('copy', index)"
                            style="width: 24px;" />
                        <i style="color:#ED5E5E" @click="handler('delete', index)"
                            class=" cursor-pointer ri-delete-bin-5-fill me-1 align-bottom"></i>
                    </div>
                </div>
                <div class="d-flex justify-content-sm-start mt-5">
                    <div class="search-box ms-2">
                        <!-- v-show="currentTabLang == 1" -->
                        <el-select  :disabled="route.query.type == 'view'"
                            @change="changeCheck(item, index)"
                            :class="[(isCheckForm && !item.value && item.isShow) && 'is-invalid']" v-model="item.value"
                            :placeholder="currentTabLang == 1?  getLangValueByKey('product-template.selectDataBase'): getLangValueByKey('product-template.selectDataBase', 'en')" size="large"
                            style="width: 300px;" clearable>
                            <el-option v-for="item1 in menuList" :key="item1.id" :label="currentTabLang == 1? item1.name: item1.name_en"
                                :value="item1.role_key" />
                        </el-select>
                        <!-- <el-select v-show="currentTabLang == 2" :disabled="route.query.type == 'view'"
                            @change="changeCheck(item, index)"
                            :class="[(isCheckForm && !item.value_en && item.isShow) && 'is-invalid']"
                            v-model="item.value" :placeholder="getLangValue('product-template.selectDataBase')"
                            size="large" style="width: 300px;" clearable>
                            <el-option v-for="item1 in menuList" :key="item1.id" :label="item1.name_en"
                                :value="item1.name_en" />
                        </el-select> -->
                    </div>
                </div>
                <!-- 显示表格 -->
                <table class="table table-bordered table-nowrap">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" width="10%">{{ currentTabLang==1?  getLangValueByKey("product-template.number"):  getLangValueByKey("product-template.number", 'en') }}</th>
                            <th scope="col" width="20%">{{getLangValue('product-management', "pid")}}</th>
                            <th scope="col" width="20%">{{ currentTabLang==1? getLangValueByKey("attribute.name"):  getLangValueByKey("attribute.name", 'en') }}</th>
                            <th scope="col" width="20%" v-if="showType && (item.extra?.template_type ==2)">{{currentTabLang==1? getLangValueByKey("product-template.structure")  :  getLangValueByKey("product-template.structure", 'en')
                                }}
                            </th>
                            <th scope="col" width="20%">{{currentTabLang==1? getLangValueByKey("product-template.proportion"):  getLangValueByKey("product-template.proportion", 'en')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="vertical-align: middle">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td v-if="showType && ( item.extra?.template_type ==2)"></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
                <div class="d-flex justify-content-sm-end mt-5">
                    <div class="search-box ms-2">
                        <input type="text" class="form-control" disabled
                            :placeholder=" currentTabLang==1? getLangValueByKey('product-template.searchProducts'): getLangValueByKey('product-template.searchProducts', 'en')" />
                        <i class="ri-search-line search-icon"></i>
                    </div>
                    <!-- 供应链 -->
                    <el-select class="mx-2"
                        :placeholder="currentTabLang==1? getLangValueByKey('my.supply-chain.name'):  getLangValueByKey('my.supply-chain.name', 'en') " size="large"
                        style="width: 200px; height: 37.5px;" clearable disabled>
                        <el-option v-for="item1 in []" :key="item1.key" :label="item1.zh" :value="item1.key">
                        </el-option>
                    </el-select>
                    <!-- 数据公开类型 -->
                    <el-select :placeholder="currentTabLang==1? getLangValueByKey('attribute.dataPublicType'): getLangValueByKey('attribute.dataPublicType', 'en')" size="large"
                        style="width: 200px; height: 37.5px;" clearable disabled>
                        <el-option v-for="item1 in []" :key="item1.value" :label="item1.label" :value="item1.value">
                        </el-option>
                    </el-select>
                </div>
                <table class="table table-bordered table-nowrap">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" width="33%">{{getLangValue('product-management', "pid")}}</th>
                            <th scope="col" width="33%">{{ currentTabLang==1? getLangValueByKey("attribute.name"):  getLangValueByKey("attribute.name", 'en') }}</th>
                            <th scope="col" width="33%">{{currentTabLang==1?   getLangValueByKey("product-template.type"): getLangValueByKey("product-template.type", 'en') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="vertical-align: middle">
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-card>
    </template>
</template>
<style scoped lang="scss">
.product-template-compositionStructure {
    .is-invalid {
        border: 1px solid #f06548;
        border-radius: 4px;
    }

    // :deep(.form-check-input:checked) {
    //     background-color: #0AB39C;
    //     border-color: #0AB39C;
    // }
}
</style>